export default class Flex {
    static  SPACE_AROUND = "space-around";
    static  SPACE_BETWEEN = "space-between";
    static  SPACE_EVENLY = "space-evenly";
    static  START = "flex-start";
    static  END = "flex-end";
    static  CENTER = "center";
    static  STRETCH = "stretch";
}